/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-plusplus */
/* eslint-disable no-prototype-builtins */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {resolveCurrencyModeOnLimit} from '../components/silverCoins/constants'
import {
  BetResultStatusEnum,
  RouletteBetTargetTypeEnum,
  RouletteColorEnum,
  RouletteParityEnum,
  RouletteRoundStatusEnum,
  RouletteKingStateEnum,
} from './enum'

export interface ResultInfo {
  round_no?: string
  my_bet?: number
  my_win?: number
  others_win?: number
  hit_target?: number
  coin_num?: number
  top5_wins?: Array<number>
  win_bet_targets?: Array<number>
  bigger_winners?: Array<{
    id?: number
    win_coins?: number
    name?: string
    avatar?: string
    zy_id?: string
  }>
  random_multiplier?: {
    hit_bet_targets?: Array<{
      bet_target: number
      multiplier: number
    }>
    reward_coins?: number
  }
  guide_to_coin_game?: boolean // 是否引导去金币场
  coin_guide_pop?: {
    cost_chips?: number
    miss_coins?: number
    /** @deprecated 改用 miss_amount_decimal */
    miss_amount?: number
    miss_amount_decimal?: number
  }
}

interface InitialStateType {
  base?: {
    preActFinished: boolean
    playing: boolean
    loading: boolean
    showGuide: boolean
    guideStep: number
    isWebMsgGet: boolean
    betChip?: number
    resultAmis: boolean
  }
  home?: {
    free_card?: {
      // 金币卡信息
      value: number // 	面值
      num: number //	数量
    }[]
    target_order_list?: Array<{
      point: number
      color: RouletteColorEnum
    }>
    bet_chips?: Array<number>
    coin_num?: number
    today_win_sum?: number
    playing_users?: number
    own?: {
      id: number
      name: string
      zy_id: string
      avatar: string
    }
    history_results?: {
      round_no: number
      day_round: number
      hit_target: {
        point: number
        color: RouletteColorEnum
        parity: RouletteParityEnum
      }
    }[]
    top5_list?: Array<{
      id: number
      name: string
      zy_id: string
      avatar: string
    }>
    greedy_min_bet?: {
      price: number
      countdown: number
    }
    chip_game_visible?: boolean // 银币游戏是否可见
    currency_mode?: number // 0 金币场 1 银币场
    my_chips?: number // 银币余额
    chip_game_limit_reached?: boolean // 银币游戏达到限制
  }
  roundInfo?: {
    betCountInfo?: any
    repeat_flag?: boolean
    otherUserChipsInfo?: any
    round_no?: string
    day_round?: number
    status_expire?: number
    hit_target?: number
    round_status?: RouletteRoundStatusEnum
    pay_amount?: number // 下注实际扣减金额
    bet_targets?: Array<{
      tid: number
      fix_point: number
      odd: number
      my_bet?: number
      sum_bet?: number
      point_range: Array<number>
      type: RouletteBetTargetTypeEnum
      parity: RouletteParityEnum
      color: RouletteColorEnum
      bet_chips: Array<{
        value: number
        num: number
        type: number // 0 金币 1 银币
      }>
    }>
    winUsers?: Array<{
      seatId?: number
      amount?: number
    }>
    random_multiplier?: {
      hit_bet_targets?: Array<{
        bet_target: number
        multiplier: number
      }>
    }
  }
  result?: ResultInfo
  kingInfo?: {
    resultShow?: boolean // 是否开奖
    open_times?: Array<string> // 活动开始时间和结束时间
    status?: RouletteKingStateEnum // 轮次状态:0:功能未开启;1:蓄力阶段;2:抢夺阶段
    jackpot_open_need?: number // 开启轮次抢夺需要的金币数额
    king_jackpot?: number // 当前奖池金额
    count_down?: number // 轮次倒计时
    champion_score?: number // 冠军积分
    my_score?: number // 我的积分
    champion_info?: {
      // 冠军
      id: number
      name: string
      zy_id: string
      avatar: string
    }
  }
}

export const get_roulette_homepage = createAsyncThunk<
  any,
  {currency_mode?: number} | void
>('get_roulette_homepage', async (arg, store: any) => {
  const {currency_mode} = (arg ?? {}) as {currency_mode?: number}
  const {deviceinfo} = store.getState().env
  const resp = await http.post(
    '/live/ground/r_homepage',
    {
      ...deviceinfo,
      ...(currency_mode !== undefined ? {currency_mode} : {}),
    },
    {
      store,
      xcErrorToast: true,
    }
  )
  return resp.data.data
})
export const roulette_king_homepage = createAsyncThunk(
  'roulette_king_homepage',
  async (arg, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/ground/r_king_homepage',
      {
        ...deviceinfo,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export const roulette_bet = createAsyncThunk(
  'roulette_bet',
  async (
    arg: {
      bet_tid?: number
      h_web_room_id?: number
      bet_amount?: number
      bet_repeat?: boolean
      is_free_card?: boolean // 是否使用金币卡
      currency_mode?: number // 0 金币场 1 银币场
    },
    store: any
  ) => {
    const {deviceinfo, otherInfo} = store.getState().env
    const currentCurrencyMode =
      store.getState().Animal_Vulture?.home?.currency_mode
    const resp = await http.post(
      '/live/ground/r_bet',
      {
        ...arg,
        currency_mode: arg.currency_mode ?? currentCurrencyMode,
        source: otherInfo.from,
        ...deviceinfo,
      },
      {
        store,
        xcErrorToast: true,
      }
    )

    return resp.data.data
  }
)
export const get_roulette_result = createAsyncThunk(
  'get_roulette_result',
  async (
    arg: {
      round_no?: string
      currency_mode?: number
    },
    store: any
  ) => {
    const {deviceinfo} = store.getState().env
    const currentCurrencyMode =
      store.getState().Animal_Vulture?.home?.currency_mode
    const resp = await http.post(
      '/live/ground/r_result',
      {
        ...arg,
        currency_mode: arg.currency_mode ?? currentCurrencyMode,
        ...deviceinfo,
      },
      {
        store,
        xcErrorToast: true,
      }
    )

    return resp.data.data
  }
)

export const switch_currency_mode = createAsyncThunk(
  'roulette/switch_currency_mode',
  async (arg: {target_mode: number}, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/game/switch_currency_mode',
      {
        game_type: 12,
        target_mode: arg.target_mode,
        ...deviceinfo,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    await store.dispatch(get_roulette_homepage({}))
    return resp.data.data
  }
)

const initialState: InitialStateType = {}

const initData: InitialStateType = {
  roundInfo: {
    winUsers: [],
    betCountInfo: {},
  },
  base: {
    preActFinished: false,
    playing: true,
    loading: true,
    isWebMsgGet: false,
    showGuide: false,
    resultAmis: false,
    guideStep: 0,
  },
  home: {
    chip_game_visible: false,
    currency_mode: 0,
    my_chips: 0,
    chip_game_limit_reached: false,
  },
  result: {},
  kingInfo: {},
}

export const rouletteSlice = createSlice({
  name: 'roulette',
  initialState,
  reducers: {
    initData: (state) => {
      Object.assign(state, initData)
    },
    updatePlaying: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          playing: action.payload,
        },
      })
    },
    updateKingInfo: (state, action: PayloadAction<any>) => {
      const {kingInfo} = state
      Object.assign(state, {
        kingInfo: {
          ...kingInfo,
          ...action.payload,
        },
      })
    },
    updateResultAmis: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          resultAmis: action.payload,
        },
      })
    },
    updateLoading: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          loading: action.payload,
        },
      })
    },
    preActFinished: (state) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          preActFinished: true,
        },
      })
    },
    updateWebMsgGet: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          isWebMsgGet: action.payload,
        },
      })
    },
    updateShowGuide: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          showGuide: action.payload,
        },
      })
    },
    updateGuideStep: (state, action: PayloadAction<number>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          guideStep: action.payload,
        },
      })
    },
    changeBetChip: (state, action: PayloadAction<number>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          betChip: action.payload,
        },
      })
    },
    updateRoundInfo: (state, action: PayloadAction<any>) => {
      const {roundInfo} = state
      Object.assign(state, {
        roundInfo: {
          ...roundInfo,
          ...action.payload,
        },
      })
    },
    clearBetTargets: (state, action?: PayloadAction<any>) => {
      const {roundInfo} = state
      const temp = roundInfo.bet_targets.map((item) => ({
        ...item,
        my_bet: 0,
        sum_bet: 0,
      }))
      Object.assign(state, {
        roundInfo: {
          ...roundInfo,
          bet_targets: temp,
        },
      })
    },
    updateHome: (state, action: PayloadAction<any>) => {
      const {home} = state
      Object.assign(state, {
        home: {
          ...home,
          ...action.payload,
        },
      })
    },
    updateResult: (state, action: PayloadAction<any>) => {
      const {result} = state
      Object.assign(state, {
        result: {
          ...result,
          ...action.payload,
        },
      })
    },
    clearResult: (state, action?: PayloadAction<any>) => {
      Object.assign(state, {
        result: {},
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(get_roulette_homepage.fulfilled, (state, action) => {
      const {roundInfo, home} = state
      const {
        target_order_list,
        bet_chips,
        coin_num,
        today_win_sum,
        own,
        history_results,
        top5_list,
        playing_users,
        greedy_min_bet,
        card_list,
        chip_game_visible,
        currency_mode,
        my_chips,
        chip_game_limit_reached,
        ...rest
      } = action.payload
      if (greedy_min_bet) {
        bet_chips.unshift(greedy_min_bet.price)
      }
      Object.assign(state, {
        roundInfo: {
          ...roundInfo,
          ...rest,
        },
        home: {
          ...home,
          target_order_list,
          bet_chips,
          coin_num,
          today_win_sum,
          own,
          history_results,
          top5_list,
          playing_users,
          greedy_min_bet,
          free_card: card_list,
          chip_game_visible,
          my_chips,
          chip_game_limit_reached,
          currency_mode: resolveCurrencyModeOnLimit(
            currency_mode ?? home?.currency_mode,
            chip_game_limit_reached
          ),
        },
      })
    })
    builder.addCase(roulette_bet.fulfilled, (state, action) => {
      const {roundInfo, home} = state
      const {
        status,
        coin_num,
        bet_targets,
        card_list,
        pay_amount,
        my_chips,
        currency_mode,
      } = action.payload
      const data =
        status === BetResultStatusEnum.success
          ? {
              roundInfo: {...roundInfo, bet_targets, pay_amount},
              home: {
                ...home,
                coin_num,
                free_card: card_list,
                ...(my_chips !== undefined ? {my_chips} : {}),
                currency_mode: resolveCurrencyModeOnLimit(
                  currency_mode ?? home?.currency_mode,
                  home?.chip_game_limit_reached
                ),
              },
            }
          : {}
      Object.assign(state, data)
    })
    builder.addCase(get_roulette_result.fulfilled, (state, action) => {
      Object.assign(state, {
        result: action.payload,
      })
    })
    builder.addCase(roulette_king_homepage.fulfilled, (state, action) => {
      const {kingInfo} = state
      Object.assign(state, {
        kingInfo: {
          ...kingInfo,
          ...action.payload,
        },
      })
    })
    builder.addCase(switch_currency_mode.fulfilled, (state, action) => {
      const {home} = state
      Object.assign(state, {
        home: {
          ...home,
          currency_mode: action.payload.currency_mode,
        },
      })
    })
  },
})
export default rouletteSlice.reducer
export const rouletteActions = rouletteSlice.actions
